var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationNoteDecline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A9F6E26B-3DA7-4E45-8B53-6C9A805717FC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Feed-Left",
    transform: "translate(-810.000000, -1670.000000)",
    fill: "#CA5442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(792.000000, 1612.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-approve",
    transform: "translate(16.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,20.0001464 L2,3.99985364 C2,2.89484758 2.89317632,2 3.99985364,2 L20.0001464,2 C21.1051524,2 22,2.89317632 22,3.99985364 L22,20.0001464 C22,21.1051524 21.1068237,22 20.0001464,22 L3.99985364,22 C2.89484758,22 2,21.1068237 2,20.0001464 Z M12,10.5857864 L9.52199909,8.10778552 C9.13256673,7.71835316 8.501437,7.72038841 8.1109127,8.1109127 C7.71766575,8.50415966 7.71898833,9.13320189 8.10778552,9.52199909 L10.5857864,12 L8.10778552,14.4780009 C7.71898833,14.8667981 7.71766575,15.4958403 8.1109127,15.8890873 C8.501437,16.2796116 9.13256673,16.2816468 9.52199909,15.8922145 L12,13.4142136 L14.4780009,15.8922145 C14.8674333,16.2816468 15.498563,16.2796116 15.8890873,15.8890873 C16.2823343,15.4958403 16.2810117,14.8667981 15.8922145,14.4780009 L13.4142136,12 L15.8922145,9.52199909 C16.2810117,9.13320189 16.2823343,8.50415966 15.8890873,8.1109127 C15.498563,7.72038841 14.8674333,7.71835316 14.4780009,8.10778552 L12,10.5857864 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationNoteDecline);
export default __webpack_public_path__ + "static/media/application_note_decline.7f4c8a0fcf8005893b76c27f3d531f43.svg";
export { ForwardRef as ReactComponent };